export default (state, action) => {
    let new_state;


    switch (action.type) {
        case 'update-invitee':
            state.invitees[action.index] = action.invitee;
            new_state = {
                ...state,
                invitees: state.invitees
            }
            break;
        case 'add-invitee':
            new_state = {
                ...state,
                invitees: state.invitees.concat([{ invitee: '', role: null }])
            }
            break;
        case 'remove-invitee':
            state.invitees.splice(action.index, 1)
            new_state = {
                ...state,
                invitees: state.invitees
            }
            break;
        default:
            new_state = {
                ...state
            }
            break;
    }


    return new_state;

}